import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

export const downloadPdfFromHtml = (element: HTMLElement | null, outputName: string) => {
	if (!element) {
		console.error('Element not found');
		return;
	}

	html2canvas(element, { useCORS: true }).then((canvas) => {
		var imgData = canvas.toDataURL('image/png');
		var doc = new jsPDF('p', 'mm');
		const imgProps = doc.getImageProperties(imgData);

		const pdfWidth = doc.internal.pageSize.getWidth();
		const pageHeight = doc.internal.pageSize.getHeight();
		const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

		let position = 0;
		let heightLeft = pdfHeight;

		doc.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);

		heightLeft -= pageHeight;

		while (heightLeft >= 0) {
			position = heightLeft - pdfHeight; // top padding for other pages
			doc.addPage();
			doc.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
			heightLeft -= pageHeight;
		}

		doc.save(`${outputName}.pdf`);
	});
};

export const makeCanvasFromHtml = (element: HTMLElement | null, cb: (canvas: HTMLCanvasElement) => void) => {
	if (!element) {
		console.error('Element not found');
		return;
	}

	html2canvas(element, { useCORS: true }).then((canvas) => {
		cb(canvas);
	});
};
